import api from './http';
import { DocPage, NavGroup } from '../types/doc';

export const fetchNavigation = async (): Promise<NavGroup> => {
  const { data } = await api.get<NavGroup>('/docs/nav');
  return data;
};

export const fetchDocs = async (): Promise<DocPage[]> => {
  const { data } = await api.get<DocPage[]>('/docs');
  return data;
};

export const fetchDocBySlug = async (slug: string): Promise<DocPage> => {
  const { data } = await api.get<DocPage>(`/docs/${slug}`);
  return data;
};

export const createDoc = async (payload: Partial<DocPage>, token: string) => {
  const { data } = await api.post<DocPage>('/docs', payload, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return data;
};

export const updateDoc = async (id: string, payload: Partial<DocPage>, token: string) => {
  const { data } = await api.put<DocPage>(`/docs/${id}`, payload, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return data;
};

export const deleteDoc = async (id: string, token: string) => {
  await api.delete(`/docs/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

